
import { combineReducers } from 'redux';

import pixels from './pixels';

export default combineReducers( {
  pixels,
} );
